import { ISubcontractor } from 'src/app/modules/logged/subcontractors/store/types';
import { ISiteManagerTimeRecordsFilters } from 'src/app/modules/logged/time-records/store/types';

export class SetCurrentTab {
    static readonly type = '[time trackings] set current tab';
    constructor(public tab?: 'GENERAL', public filters?: Partial<ISiteManagerTimeRecordsFilters>) { }
}

export class SetSearchField {
    static readonly type = '[time trackings] set search field';
    constructor(public value: string) { }
}

export class SetFiltersBasedOnTab {
    static readonly type = '[time trackings] set filters based on tab';
    constructor(public filters?: Partial<ISiteManagerTimeRecordsFilters>) { }
}

export class FetchAllTimeRecords {
    static readonly type = '[time trackings] fetch all time trackings';

    constructor(public params: any) {
    }
}
